/* Pétale PDP — variant → hero image + thumbnail sync (select + auto-scroll).
   Additive: runs after the theme's own variant handler and guarantees the
   matching thumbnail is highlighted, the main image matches, and the thumbnail
   strip is scrolled so the active thumb is in view. Scrolls the strip on the X
   axis only (never the page), so the mobile layout is untouched. */
(function () {
  'use strict';

  function baseName(u) {
    return String(u || '').split('?')[0].split('/').pop().split('.')[0];
  }

  function sync() {
    var picker = document.querySelector('[data-lp-variant-picker]');
    if (!picker) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.lp-hero__thumb'));
    if (!thumbs.length) return;

    var variants;
    try { variants = JSON.parse(picker.getAttribute('data-variants') || '[]'); }
    catch (e) { return; }

    var count = parseInt(picker.getAttribute('data-options-count') || '1', 10);
    var vals = [];
    for (var i = 1; i <= count; i++) {
      var a = picker.querySelector('[data-option-index="' + i + '"] .is-active');
      vals.push(a ? a.getAttribute('data-option-value') : null);
    }
    var v = variants.find(function (x) {
      return x.options && x.options.every(function (val, idx) { return val === vals[idx]; });
    });
    if (!v) return;

    var match = null;
    var mid = (v.featured_media && v.featured_media.id != null) ? String(v.featured_media.id) : null;
    if (mid) {
      thumbs.forEach(function (t) {
        if (!match && t.getAttribute('data-media-id') === mid) match = t;
      });
    }
    if (!match && v.featured_image && v.featured_image.src) {
      var b = baseName(v.featured_image.src);
      thumbs.forEach(function (t) {
        if (!match && baseName(t.getAttribute('data-src')) === b) match = t;
      });
    }
    if (!match) return;

    // Highlight the matching thumbnail.
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    match.classList.add('is-active');

    // Make sure the main image matches the selected variant's thumbnail.
    var main = document.querySelector('.lp-hero__main img');
    var src = match.getAttribute('data-src');
    if (main && src) {
      if (typeof window.lpSwapHeroImage === 'function') {
        // Use the shared flash-free crossfade (preloaded + no pink flash).
        window.lpSwapHeroImage(src, match.getAttribute('data-alt') || main.alt);
      } else if (baseName(main.getAttribute('src')) !== baseName(src)) {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.src = src;
        main.alt = match.getAttribute('data-alt') || main.alt;
      }
    }

    // Auto-scroll the thumbnail strip (X only) so the active thumb is in view.
    var list = match.closest('.lp-hero__thumbs');
    if (list) {
      var lr = list.getBoundingClientRect();
      var tr = match.getBoundingClientRect();
      if (tr.left < lr.left + 1 || tr.right > lr.right - 1) {
        var d = (tr.left + tr.width / 2) - (lr.left + lr.width / 2);
        if (typeof list.scrollBy === 'function') list.scrollBy({ left: d, behavior: 'smooth' });
        else list.scrollLeft += d;
      }
    }
  }

  // Run just after the theme's own option-click handler updates the DOM.
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-lp-variant-picker] [data-option-value]')) setTimeout(sync, 60);
  }, true);

  // Align once on load (in case the selected variant's thumb isn't the first).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(sync, 150); });
  } else {
    setTimeout(sync, 150);
  }
})();
